import gql from 'graphql-tag';

export default gql`
  query {
    languageState @client {
      locale
    }
  }
`;



// WEBPACK FOOTER //
// ./app/containers/LanguageProvider/graphql/getlocale.gql.js